import { useCallback, useEffect, useState } from "react";

import type { AsyncSelectSearchHook } from "../BoundAsyncSelect";

export function useAsyncSelectStaticListHook<TItem extends { name: string }>(
	services: TItem[],
): AsyncSelectSearchHook<TItem> {
	const [items, setItems] = useState<TItem[]>(services);
	const [loading, setLoading] = useState(false);
	const [endCursor] = useState<string | null>(null);
	const [hasNextPage] = useState(false);
	const [searchText, setSearchText] = useState("");

	const execute = useCallback(
		async (search: string, _cursor: string | null): Promise<void> => {
			setLoading(true);

			const filteredItems = services.filter((service) =>
				service.name.toLowerCase().includes(search.toLowerCase()),
			);

			setItems(filteredItems);

			setLoading(false);

			return Promise.resolve();
		},
		[services],
	);

	const resetSearch = useCallback(async (): Promise<void> => {
		setSearchText("");
		return execute("", null);
	}, [execute]);

	useEffect(() => {
		setSearchText("");
		void execute("", null);
	}, [services, execute]);

	return {
		resetSearch,
		execute,
		items,
		loading,
		hasNextPage,
		endCursor,
		searchText,
		setSearchText,
	};
}
